import { put, call, getContext } from 'redux-saga/effects';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';
import { joinFairPlay as joinFairPlayService } from '../../../../services/moderationActionCheck';
import { joinFairPlayFail, joinFairPlayStart, joinFairPlaySuccess } from '../../../reducers/fairPlay';

export function* joinFairPlay() {
  const httpApi: IHttpApi = yield getContext('httpApi');
  const logger: ILogger = yield getContext('logger');

  yield put(joinFairPlayStart());

  const response = yield call(joinFairPlayService, {
    httpApi,
    logger,
  });

  if (response.success) {
    yield put(joinFairPlaySuccess());
  } else {
    yield put(joinFairPlayFail(response.payload));
  }
}
